export const ROLE = {
  TRANSPORTADORA: 'T',
  ADMINISTRADOR: 'A',
  DEPOSITANTE: 'D',
  FORNECEDOR: 'F',
  ANALISTACD: 'ANCD',
};
